export default __webpack_public_path__ + "static/media/pexels-photo-6097702.29885b69.webp";